import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Zap, Github } from 'lucide-react';
import { useAuth } from '../auth.jsx';

export default function Login() {
  const { user, loading, login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const error = params.get('error');

  useEffect(() => {
    if (!loading && user) nav('/', { replace: true });
  }, [loading, user, nav]);

  return (
    <div className="h-full flex items-center justify-center" style={{ background: 'var(--bg)' }}>
      <div
        style={{
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 16, padding: '40px 36px', width: 380, maxWidth: '90vw',
          boxShadow: '0 20px 60px rgba(0,0,0,.4)',
        }}
      >
        <div className="flex items-center gap-2.5 mb-6">
          <span style={{ background: 'var(--primary)', borderRadius: 9 }} className="w-9 h-9 flex items-center justify-center">
            <Zap size={18} color="#0B0E14" strokeWidth={2.5} />
          </span>
          <span style={{ fontFamily: 'IBM Plex Mono', color: 'var(--text)', fontWeight: 600, fontSize: '1.15rem' }}>
            Corridors
          </span>
        </div>

        <h1 style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text)', margin: '0 0 6px' }}>
          Sign in
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '.85rem', margin: '0 0 24px' }}>
          Build and run automations on your own Cloudflare stack.
        </p>

        {error && (
          <div style={{ background: 'rgba(239,68,68,.1)', border: '1px solid rgba(239,68,68,.3)', borderRadius: 8, padding: '10px 12px', color: 'var(--red)', fontSize: '.8rem', marginBottom: 16 }}>
            {error}
          </div>
        )}

        <button
          onClick={() => login('google')}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            padding: '11px 16px', borderRadius: 9, border: '1px solid var(--border-2)',
            background: '#fff', color: '#1f2328', fontWeight: 600, fontSize: '.9rem', cursor: 'pointer',
            marginBottom: 12,
          }}
        >
          <GoogleG /> Continue with Google
        </button>

        <button
          onClick={() => login('github')}
          style={{
            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            padding: '11px 16px', borderRadius: 9, border: '1px solid var(--border-2)',
            background: '#1f2328', color: '#fff', fontWeight: 600, fontSize: '.9rem', cursor: 'pointer',
          }}
        >
          <Github size={18} /> Continue with GitHub
        </button>

        <p style={{ color: 'var(--text-muted)', fontSize: '.72rem', marginTop: 22, lineHeight: 1.5 }}>
          Free plan includes up to 5 workflows. Upgrade to Premium anytime for unlimited.
        </p>
      </div>
    </div>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.9 2.4 30.4 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.9 6.1C12.4 13.2 17.7 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.1 24.6c0-1.6-.1-3.1-.4-4.6H24v9.1h12.4c-.5 2.9-2.1 5.3-4.6 7l7.1 5.5c4.2-3.9 6.7-9.6 6.7-16z"/>
      <path fill="#FBBC05" d="M10.5 28.7c-.5-1.4-.8-2.9-.8-4.7s.3-3.3.8-4.7l-7.9-6.1C1 16.3 0 20 0 24s1 7.7 2.6 10.8l7.9-6.1z"/>
      <path fill="#34A853" d="M24 48c6.4 0 11.9-2.1 15.9-5.8l-7.1-5.5c-2 1.3-4.5 2.1-8.8 2.1-6.3 0-11.6-3.7-13.5-9.8l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/>
    </svg>
  );
}
